"use client";
import React from "react";
// import { Lato } from "next/font/google";

import Screen from "../components/Screen";
import ProfileHeaderSection from "../components/ProfileHeaderSection";
import HeaderDescription from "../components/HeaderDescription";
import HeaderBox from "../components/Box/HeaderBox";
import { BackButton, FowardButton } from "../components/forms/DashboardButton";

import { useNavigate } from "react-router-dom";
import { value } from "../components/image";

const Values = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate("/organization");
  };
  const handlePrev = () => {
    navigate("/mission");
  };

  const text = [
    {
      title: "Service",
      text: "We don’t sell to our customers, we seek to serve them first. We ask you to think about how you can make life easier for the thousands of care centers whose job is to make sure Africa is in good health? This is the main question that every LifeBanker should ask themselves everyday. How can I serve our amazing health workers and hospitals? How can I write  code to improve their work? How can I use persuasion to ensure they know that LifeBank is the easiest way to get what they need? How can I deliver their supplies reliably, quickly, and well? How do I tell their stories in a way that will make them proud? How do I ensure LifeBank is financially healthy so it can continue to serve them and save them money? How can I constantly innovate on their behalf? How do I improve the safety of the supplies they receive? How do I hire the right people to create an amazing experience for the hospitals when they choose LifeBank? We are in the business of serving care centers because if we serve them well, they will in turn deliver for their patients and deliver revenue for us! ",
    },
    {
      title: "Respect",
      text: " We respect each other. No politics, no politicking, no drama. Put your head down and execute. At this stage in our business, we must be a high performing team here to deliver service at scale! Millions of patients are relying on us. You are an important part of that team and everyone at LifeBank must respect the work you do. We speak to each other with respect, even when we must disagree. We encourage debate but not toxic debate. Real LifeBankers are so busy innovating for our patients and those who support them that they don’t have the time to gossip, or behave poorly.  We do not accept bullying, gossiping about others, insulting others, any harassment, and any retaliation. Just work. You are allowed to be passionate about your position, and debate with respect. When we have cultivated a respectful environment, passionate debate becomes the norm, without devolving into toxicity. ",
    },
    {
      title: "Duty",
      text: "We take responsibility for our goals and growth. When you are given a task, you fully own it and execute like your name is on the building.",
    },
    {
      title: "Ownership",
      text: "At LifeBank, each of us takes responsibility for our goals and our growth. We are a high performance team and everyone is treated like an adult, fully in charge of your life, and therefore the CEO of you. This means that when you are given a task you fully own it. When you have a deadline, you get things done. Your commitment is a contract and you execute like your name is on the building… because one day it might be. You are the boss of your role. Own it. LifeBank will create a buffet of learning opportunities, pls. Use it!",
    },
    {
      title: "Excellence",
      text: "We reward excellence, and excellence means doing things quickly and well. Speed is the only thing that differentiates great business from just ok ones. Companies who do not do things well, do not succeed. Doing things quickly and well is an important moat around LifeBank’s business. When you become a LifeBanker, it means you have agreed to perform excellently because when even 1 person does not perform well, it destroys the value everyone else on our team is working to create. It is those who do things quickly and well that get rewarded at LifeBank. How do you know if you are excellent, the data will show it. Your numbers will show it.",
    },
    {
      title: "Data",
      text: "In God we trust, but everyone else should bring data. We base decisions on data and prioritize facts over assumptions.",
    },
  ];
  return (
    <div className="bg-white w-full">
      <Screen>
        <ProfileHeaderSection />
        <HeaderDescription
          maintext={"Dashboard"}
          subtext={"Our Team"}
          subsubtext={"About Value"}
        />
        <h1 className={`font-bold marker:text-4xl text-lightDark my-4`}>
          Our Values
        </h1>
        <div className="">
          <HeaderBox text="A calm high-performing environment where you can do good, learn fast, and do well!" />
        </div>
        <div className={`  mt-4 text-basetext leading-7 text-left`}>
          <ol className="space-y-4">
            {text.map((paragraph, index) => (
              <li key={index} className="">
                <span className="font-semibold">
                  {index + 1}. {paragraph.title} -
                </span>{" "}
                {paragraph.text}
              </li>
            ))}
          </ol>
        </div>

        <div className="flex mx-auto justify-center w-full my-8">
          <img
            src={value}
            alt="team/value"
            className="rounded h-60 w-full object-fill"
          />
        </div>

        <div className="my-2 flex gap-4 right-2 absolute bottom-4">
          <BackButton
            text={"Previous"}
            onClick={handlePrev}
            subText={"Mission& Vision"}
          />
          <FowardButton
            text={"Next"}
            onClick={handleNext}
            subText={"Organizational Chart"}
          />
        </div>
      </Screen>
    </div>
  );
};

export default Values;
